<template>
    <div class="w-full h-[1px] bg-black" />
</template>

<script>
export default {
    name: 'AtomSectionSeparator'
}
</script>
